import { useTexte } from '../../texte'
import type { OutboxEntry } from '../../lib/outbox'
import { bubbleTime } from '../../lib/format'
import { datumText, uhrText, type Uhr } from '../../lib/ortszeit'
import { OrtungBild } from '../../components/Wetterbilder'
import { Warteknoepfe, Wartemarke } from './Wartend'

/**
 * A weather card that waits for the net (#98, 1.54.0).
 *
 * It stands where the card will stand, pale and dashed like a waiting
 * message, and says what it knows: the place as two numbers (no name yet --
 * the name comes from Apple with the weather) and the moment of the tap.
 * No temperature, no hours, no attribution: nothing of that exists yet, and
 * a card that showed a zero would claim a measurement. The marker and the
 * buttons are the waiting bubble's, so that a stuck card looks and works
 * like a stuck message.
 */
export function Wetterwartet({ eintrag, versatz = null }: { eintrag: OutboxEntry; versatz?: Uhr }) {
  const t = useTexte().wetterkarte
  const wetter = eintrag.wetter
  if (wetter === undefined) return null
  return (
    <div className="bubble-row bubble-row--own">
      <div className="bubble bubble--wartet bubble--wetter-wartet" data-wetter-wartet={eintrag.key}>
        <span className="bubble__kopfzeile">
          <span className="bubble__wer" />
          <span className="bubble__meta">
            {bubbleTime(eintrag.angelegt)}
            <Wartemarke eintrag={eintrag} />
          </span>
        </span>
        <div className="wetterkarte wetterkarte--wartet">
          <div className="wetterkarte__kopf">
            <div className="wetterkarte__links">
              <span className="wetterkarte__ort">
                {t.koordinaten(wetter.lat, wetter.lon)}
                <OrtungBild size={14} title={t.standort} />
              </span>
              <span className="wetterkarte__wann" data-gemerkt={wetter.at}>
                {t.gemerkt(`${datumText(wetter.at, versatz)}, ${uhrText(wetter.at, versatz)}`)}
              </span>
            </div>
          </div>
          <p className="wetterkarte__lage">{t.kommtMitNetz}</p>
        </div>
        {eintrag.problem !== undefined && <p className="wartet-problem">{eintrag.problem}</p>}
        <Warteknoepfe eintrag={eintrag} />
      </div>
    </div>
  )
}
